import _ from "lodash";
import { useEffect, useRef, useState } from "react";
import {queryParamsStore} from './QueryParamsStore/QueryParamsStore';

const cache = {};

const fetchDistanceMatrix = async (buildingId: string, isWheelchair: boolean) => {
  const cacheKey = JSON.stringify({buildingId, isWheelchair})

  if (!cache[cacheKey]) {
    const url = `/Buildings/${buildingId}/distanceMatrix${isWheelchair ? "?isWheelChair=1" : ""}`;
    const requestUrl = url.startsWith('/') ? `${process.env.REACT_APP_API_URL}${url}` : url;

    const resp = await fetch(requestUrl);
    cache[cacheKey] = await (await resp.text()).split("\n").map(x => x.split(","));
  }

  const lines = cache[cacheKey];

  const [nodeIdsIdxLut, ...distanceMatrix] = lines;
  return { nodeIdsIdxLut, distanceMatrix };
};

export type LookupDistanceFunction = (fromNodeId: string, toNodeId: string) => number | undefined

export const useDistanceMatrix = () => {

  const buildingId = queryParamsStore.queryParams.buildingId as string
  const isWheelchair = !!queryParamsStore.queryParams.WheelChair

  const [isReady, setIsReady] = useState(false);
  const ctx = useRef({
    nodeIdsIdxLut: [] as string[],
    distanceMatrix: [] as string[][]
  });
  useEffect(() => {
    fetchDistanceMatrix(buildingId, isWheelchair).then(res => {
      ctx.current = res;
      setIsReady(true);
    });
  }, [buildingId, isWheelchair]);

  const lookupDistance : LookupDistanceFunction = (fromNodeId: string, toNodeId: string) => {
    if (!isReady) {
      return undefined;
    }
    const { nodeIdsIdxLut, distanceMatrix } = ctx.current;

    const fromNodeIdIdx = nodeIdsIdxLut.indexOf(fromNodeId);
    const toNodeIdIdx = nodeIdsIdxLut.indexOf(toNodeId);

    if (fromNodeIdIdx === -1 || toNodeIdIdx === -1) {
      return undefined
    }

    const result = distanceMatrix[fromNodeIdIdx][toNodeIdIdx]
    if (result === "NA") {
      return 0
    } else {
      return +result
    }
  };

  return { isReady, lookupDistance };
};
